import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { RESULTS_PATH } from "@/helpers/resultsCopy";

const LegacyResultsRedirect = () => {
  const { search, hash } = useLocation();
  return <Navigate to={`${RESULTS_PATH}${search}${hash}`} replace />;
};

export default LegacyResultsRedirect;
